export const recordingSettingsFields = `
  id
  enabled
  enabledMode
  privacy
  autoMarkConfidential
  enabledDirection
  encryptionEnabled
  transcriptionEnabled
  sentimentEnabled
  summarizationEnabled
  storageProfileId
  storageProfile {
    id
    name
  }
`;

export const accountPreferencesFields = `
  id
  autoCreateUser
  defaultLanguage
  defaultRecordingSettings {
    ${recordingSettingsFields}
  }
`;

export const coreAppUserFields = `
  id
  accountId
  name
  status
  description
  permissions
  language

  recordingRole
`;

export const corePortalUserFields = `
  id
  name
  email
  status
  roles
  createdAt
  updatedAt
  salesforceId
  quoteToolDiscount
  permissions
  allPermissions
  type

  isAdmin
  isSuperuser
  isPartner
  isReseller
  isCustomerAdmin
  isCustomer
  isEndUser
  isNusoAdmin
  isInternalUser
  canSeePrices

  lastActiveAt
  userInvite {
    inviteDate
    inviteAccepted
    inviteAcceptDate
  }

  portalAccessLabel @client
`;


export const coreMediaPointFields = `
  id
  name
  serviceUsername
  serviceUserid
  extensionNumber
  type
  status
  createdAt
  updatedAt
  appUserId
  appUserName
  serviceId
  serviceName
  serviceType
  serviceTypeName
  serviceRootPath
  accountId
  accountName
  accountNumber
`;

export const mediaPointFields = `
  ${coreMediaPointFields}

  appUser {
    ${coreAppUserFields}

    portalUser {
      ${corePortalUserFields}
    }
  }

  appUsers {
    id
    name
  }

  recordingSettings {
    ${recordingSettingsFields}
  }
`;


